'use client';
import Icon from '@/components/Icon';
import { Portal } from '@/components/Portal';
import { useIsMobile } from '@/hooks/use-is-mobile';
import Image from 'next/image';
import { X as CloseIcon } from 'react-feather';

export const SuccessDialog = props => {
  const {
    handleClose,
    titlePc,
    titleMobile,
    textPc,
    textMobile,
    contactText = 'For any questions, contact us at <a href="mailto:cs@hisea.com">cs@hisea.com</a>',
  } = props;
  const { isMobile } = useIsMobile();
  const texts = isMobile ? textMobile || textPc : textPc;
  return (
    <Portal>
      <aside className='fixed left-1/2 top-1/2 z-[100] w-[calc(100vw-36px)] -translate-x-1/2 -translate-y-1/2 transform bg-white lg_w-[640px]'>
        <div className='relative h-full w-full  pt-[46px] '>
          <Icon
            className='absolute right-[15px] top-[15px] cursor-pointer'
            src={CloseIcon}
            size={26}
            onClick={handleClose}
          />
          <div className='pb-[44px]'>
            <Image
              className='mx-auto mb-[20px]'
              src={'/contact-us/success.svg'}
              alt='success'
              width={75.5}
              height={70}
            />
            <p
              className='mb-[20px] text-center font-roboto-medium text-[20px] leading-[28px]'
              dangerouslySetInnerHTML={{ __html: isMobile ? titleMobile || titlePc : titlePc }}
            ></p>
            {texts.map((text, index) => (
              <p
                key={index}
                className='px-[20px] text-left font-roboto-light text-[16px] font-light leading-[26px]  lg_text-center'
                dangerouslySetInnerHTML={{ __html: text }}
              ></p>
            ))}
            {contactText && (
              <p
                className='mb-[10px] mt-[10px] px-[20px] text-left font-roboto-light text-[16px] font-light leading-[26px] lg_text-center'
                dangerouslySetInnerHTML={{ __html: contactText }}
              ></p>
            )}
          </div>
        </div>
      </aside>
      <div
        className='fixed left-0 top-0 z-[99] h-[100vh] w-[100vw] bg-black opacity-60 '
        onClick={handleClose}
      ></div>
    </Portal>
  );
};
